/**
 * Response Builder Sidebar Navigation
 * 
 * Registry-driven navigation from packages/routing.
 * Per CANON.md Section 8.2 - canonical nav items only.
 */

import { NavLink } from 'react-router-dom';
import { MAIN_NAV } from '@threadlock/routing';

export default function Sidebar() {
  return (
    <aside className="w-64 bg-white border-r border-neutral-200 flex flex-col">
      {/* Logo area */}
      <div className="p-6 border-b border-neutral-200">
        <h2 className="text-lg font-bold text-neutral-900">Response Builder</h2>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-4">
        <ul className="space-y-1">
          {MAIN_NAV.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-neutral-900 text-white'
                      : 'text-neutral-700 hover:bg-neutral-100'
                  }`
                }
              >
                <span className="text-base">{item.icon}</span>
                <span>{item.label}</span>
                {item.badge && (
                  <span className="ml-auto text-xs bg-neutral-200 text-neutral-700 px-2 py-0.5 rounded-full">
                    {item.badge}
                  </span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
